<template>
  <ul class="mod__flex">
    <li :class="'mod__flex__item '">
      <input
        type="radio"
        v-model="checked"
        :id="id+1"
        :value="1">
      <label
        :for="id+1"
        class="radio side"><input type="text" placeholder="140~180H" v-model="text" class="form-control"></label>
    </li>
    <li :class="'mod__flex__item '">
      <input
        type="radio"
        v-model="checked"
        :id="id+2"
        :value="2">
      <label
        :for="id+2"
        class="radio side">固定</label>
    </li>
    <li :class="'mod__flex__item '">
      <input
        type="radio"
        v-model="checked"
        :id="id+3"
        :value="3">
      <label
        :for="id+3"
        class="radio side">時給</label>
    </li>
    <li :class="'mod__flex__item '">
      <input
        type="radio"
        v-model="checked"
        :id="id+4"
        :value="4">
      <label
        :for="id+4"
        class="radio side">不明</label>
    </li>
  </ul>

</template>
<script>
  export default {
    data: function () {
      return {
        checked: '1',
        id: '',
        text: '',
        input: {}
      }
    },
    watch: {
      checked: function () {
        if (this.checked === 1) {
          this.$emit('update:value', this.text)
        } else if (this.checked === 2) {
          this.$emit('update:value', '固定')
        } else if (this.checked === 3) {
          this.$emit('update:value', '時給')
        } else if (this.checked === 4) {
          this.$emit('update:value', '不明')
        }
      },
      text: function () {
        if (this.checked === 1) {
          this.$emit('update:value', this.text)
        }
      }
    },
    props: {
      value: {
        default: ''
      }
    },
    created: function () {
      this.id = this._uid + 'contact_time_'
    }
  }
</script>

<style lang="scss" scoped>
  .mod__flex {
    display: flex;
    flex-wrap: wrap;

    &__item {
      width: 100%;

      input[type=radio], input[type=checkbox] {
        display: none;
      }

    }
  }

  .radio.side, .checkbox.side {
    margin: 0 4px 4px 0;
    padding: 4px 4px 4px 42px;
    display: block;
  }


  .radio, .checkbox {

    &:after {
      -webkit-transition: border-color 0.2s linear;
      transition: border-color 0.2s linear;
      position: absolute;
      top: 50%;
      left: 15px;
      display: block;
      margin-top: -10px;
      width: 20px;
      height: 20px;
      border: 2px solid #bbb;
      border-radius: 6px;
      content: '';

    }
  }

  input[type=radio]:checked + .radio:before {
    opacity: 1;
  }

  .radio {
    &:before {

      transition: opacity 0.2s linear;
      position: absolute;
      top: 50%;
      left: 20px;
      display: block;
      margin-top: -5px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background-color: #5553CF;
      content: '';
      opacity: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// ContractTime.vue?4f85bb24